import React from "react";
import f1 from "../img/bayer.jpg";
import f2 from "../img/gharda.jpg";
import f3 from "../img/indofil.jpg";
import f4 from "../img/pcl.jpg";
import f5 from "../img/indoin.jpg";
import f6 from "../img/crystal.jpg";
import f7 from "../img/cropnosys.jpg";
import f8 from "../img/basf.jpg";

const Fertilize = () => {
    const images = [f1, f2, f3, f4, f5, f1, f2, f3, f4, f5 , f6, f7, f8]; // Duplicated for smooth looping

    return (
        <>
            <style>
                {`
                    .fertilizer-img {
                        height: 250px !important;
                        width: 300px;
                       
                        border-radius: 0.5rem;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    }
                `}
            </style>

            <h2 className="text-center mt-4">Our Dealership</h2>
            <div className="overflow-hidden w-full bg-gray-100 py-5">
                <div className="flex gap-4 animate-scroll">
                    {images.map((img, index) => (
                        <div key={index} className="flex-none w-1/4">
                            <img
                                src={img}
                                alt={`Slide ${index + 1}`}
                                className="fertilizer-img"
                            />
                        </div>
                    ))}
                </div>
            </div>

           
        </>
    );
};

export default Fertilize;